import { useNavigate } from "react-router-dom";
import { H1, LinkButton, PageableList, AccessCheck } from "@components";
import { GridColDef } from "@mui/x-data-grid";
import { UserRoleEnum } from "features/users/types";
import { TableActionsCell } from "../components/TableActionsCell";
import { LanguageSummary } from "../types";
import { languagesService } from "../services/languages-services";

const columns: GridColDef<LanguageSummary>[] = [
  {
    field: "id",
    headerName: "id",
    flex: 1,
  },
  {
    field: "name",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "actions",
    headerName: "Actions",
    renderCell: TableActionsCell,
    align: "center",
    sortable: false,
  },
];

export const LanguagesPage = () => {
  const navigate = useNavigate();

  const onRowClick = (params: any) => {
    const link = `/languages/${params?.row.id}/edit`;

    navigate(link);
  };

  return (
    <AccessCheck minAccessLevel={UserRoleEnum.Admin}>
      <H1 label="Languages">
        <LinkButton to="/languages/create" label="Add Language" />
      </H1>
      <PageableList
        columns={columns}
        getService={languagesService.getLanguages}
        storageId="languagesListRequest"
        // disableColumnSorting={false}
        initialRequestParams={{ orderBy: "name", descendingOrder: false }}
        onRowClick={onRowClick}
      />
    </AccessCheck>
  );
};
